import {
  CvsTypeName,
  PaymentMethodId,
  ShippingMethodId,
  ShippingMethodType,
} from "@/constants/enums";
import { OrderStatus } from "@/types/order";

export const shippingToPaymentMap = {
  [ShippingMethodId.FLAT_RATE]: [PaymentMethodId.BACS, PaymentMethodId.ECPAY_CREDIT],
  [ShippingMethodId.ECPAY_CVS_711]: [PaymentMethodId.COD, PaymentMethodId.ECPAY_CREDIT],
  [ShippingMethodId.ECPAY_CVS_FAMILY]: [PaymentMethodId.COD, PaymentMethodId.ECPAY_CREDIT],
  [ShippingMethodId.ECPAY_CVS_HILIFE]: [PaymentMethodId.COD, PaymentMethodId.ECPAY_CREDIT],
  [ShippingMethodId.ECPAY_CVS_OKMART]: [PaymentMethodId.COD, PaymentMethodId.ECPAY_CREDIT],
  // [ShippingMethodId.ECPAY_HOME_TCAT]: [PaymentMethodId.ECPAY_CREDIT],
  // [ShippingMethodId.ECPAY_HOME_POST]: [PaymentMethodId.ECPAY_CREDIT],
  // [ShippingMethodId.LOCAL_PICKUP]: [PaymentMethodId.COD],
};

export const shippingMethodToTypeMap = {
  [ShippingMethodId.FLAT_RATE]: ShippingMethodType.Home,
  [ShippingMethodId.ECPAY_CVS_711]: ShippingMethodType.CVS,
  [ShippingMethodId.ECPAY_CVS_FAMILY]: ShippingMethodType.CVS,
  [ShippingMethodId.ECPAY_CVS_HILIFE]: ShippingMethodType.CVS,
  [ShippingMethodId.ECPAY_CVS_OKMART]: ShippingMethodType.CVS,
  // [ShippingMethodId.ECPAY_HOME_TCAT]: ShippingMethodType.Home,
  // [ShippingMethodId.ECPAY_HOME_POST]: ShippingMethodType.Home,
  // [ShippingMethodId.LOCAL_PICKUP]: hippingMethodType.LocalPickup,
};

export const shippingMethodToCvsNameTypeMap = {
  [ShippingMethodId.ECPAY_CVS_711]: CvsTypeName.CVS_711,
  [ShippingMethodId.ECPAY_CVS_FAMILY]: CvsTypeName.CVS_FAMILY,
  [ShippingMethodId.ECPAY_CVS_HILIFE]: CvsTypeName.CVS_HILIFE,
  [ShippingMethodId.ECPAY_CVS_OKMART]: CvsTypeName.CVS_OKMART,
};

export const shippingMethodIdToNameMap = {
  [ShippingMethodId.FLAT_RATE]: "郵局寄送",
  [ShippingMethodId.ECPAY_CVS_711]: "7-11 超商取貨",
  [ShippingMethodId.ECPAY_CVS_FAMILY]: "全家 超商取貨",
  [ShippingMethodId.ECPAY_CVS_HILIFE]: "萊爾富 超商取貨",
  [ShippingMethodId.ECPAY_CVS_OKMART]: "OK 超商取貨",
  // [ShippingMethodId.ECPAY_HOME_POST]: "郵局寄送",
  // [ShippingMethodId.ECPAY_HOME_TCAT]: "黑貓宅配",
};

export const paymentMethodIdToNameMap = {
  [PaymentMethodId.BACS]: "銀行轉帳",
  [PaymentMethodId.ECPAY_CREDIT]: "信用卡一次付清",
  [PaymentMethodId.COD]: "貨到付款",
};

export const ORDER_STATUS_LABELS: Record<OrderStatus, string> = {
  [OrderStatus.Draft]: "訂單草稿",
  [OrderStatus.OnHold]: "保留中待付款",
  [OrderStatus.Pending]: "待付款",
  [OrderStatus.Processing]: "處理中",
  [OrderStatus.Preparing]: "備貨中",
  [OrderStatus.Shipped]: "已出貨",
  [OrderStatus.Completed]: "已完成",
  [OrderStatus.Refunded]: "已退款",
  [OrderStatus.Failed]: "失敗",
  [OrderStatus.Canceled]: "已取消",
};
